import React from "react";
import { useCountdown, pad2 } from "../lib/countdown";

export default function Countdown() {
  const { hours, minutes, seconds } = useCountdown();

  const Block = ({ value, label }) => (
    <div className="flex flex-col items-center">
      <div className="relative w-16 md:w-20 h-16 md:h-20 rounded-xl bg-gradient-to-b from-[#0a0f0a] to-[#0e1410] border border-[rgba(196,255,61,0.35)] flex items-center justify-center overflow-hidden shadow-[inset_0_1px_0_rgba(196,255,61,0.15)]">
        <div className="absolute inset-x-0 top-1/2 h-px bg-[rgba(196,255,61,0.15)]" />
        <span className="display-font text-3xl md:text-4xl font-extrabold text-[#C4FF3D] tabular-nums">
          {pad2(value)}
        </span>
      </div>
      <span className="mt-2 text-[10px] md:text-xs uppercase tracking-[0.2em] text-white/55 font-semibold">
        {label}
      </span>
    </div>
  );

  return (
    <div className="w-full">
      <div className="flex items-center justify-center gap-2 mb-3">
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" />
          <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500" />
        </span>
        <p className="text-center text-xs md:text-sm uppercase tracking-[0.18em] text-red-400 font-bold">
          Registration Closes In
        </p>
      </div>
      <div className="flex items-start justify-center gap-3 md:gap-4">
        <Block value={hours} label="Hours" />
        <span className="display-font text-3xl md:text-4xl font-extrabold text-[#C4FF3D]/40 mt-3">:</span>
        <Block value={minutes} label="Minutes" />
        <span className="display-font text-3xl md:text-4xl font-extrabold text-[#C4FF3D]/40 mt-3">:</span>
        <Block value={seconds} label="Seconds" />
      </div>
      <p className="text-center text-xs md:text-sm text-white/55 mt-4">
        After the timer hits zero, entry switches to{" "}
        <span className="text-white font-semibold">paid (₹1,999)</span>.
      </p>
    </div>
  );
}
